import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  base: {
    position: 'relative',
    height: '100%',
  },
  storybookButtonContainer: {
    position: 'absolute',
    bottom: 0,
    right: 30,
    height: 20,
    zIndex: 99999,
    backgroundColor: '#ff0000',
    borderTopLeftRadius: 6,
    borderTopRightRadius: 6,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 10,
  },
  storybookButtonText: {
    fontSize: 12,
    color: '#ffffff',
  },
});
